import { render, staticRenderFns } from "./VueCarousel.vue?vue&type=template&id=238e2e2c&"
import script from "./VueCarousel.vue?vue&type=script&lang=js&"
export * from "./VueCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238e2e2c')) {
      api.createRecord('238e2e2c', component.options)
    } else {
      api.reload('238e2e2c', component.options)
    }
    module.hot.accept("./VueCarousel.vue?vue&type=template&id=238e2e2c&", function () {
      api.rerender('238e2e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/VueCarousel.vue"
export default component.exports